import { Loader2, Send, Square, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { VoiceMessagePlayer } from '@/components/hub/VoiceMessagePlayer';

const durationLabel = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;

export const VoiceRecorderPanel = ({ recorder, prefix, sending, error, onSend, onDiscard }) => {
    const { phase, seconds, draft } = recorder;
    const message = error || recorder.error;
    if (phase === 'idle' && !message) return null;
    const pending = ['requesting', 'recording', 'stopping'].includes(phase);
    return (
        <div className="min-w-0 space-y-2" data-testid={`${prefix}-voice-panel`}>
            {message && <p role="alert" className="text-xs text-red-700" data-testid={`${prefix}-voice-error`}>{message}</p>}
            {pending && (
                <div className="flex flex-wrap items-center gap-3 rounded-lg border border-red-200 bg-red-50 p-3" data-testid={`${prefix}-recording-indicator`}>
                    <div className="flex min-w-0 flex-1 basis-full sm:basis-0 items-center gap-2 text-sm text-red-700" role="status" data-testid={`${prefix}-recording-status`}>
                        <span className="h-2 w-2 shrink-0 rounded-full bg-red-500 animate-pulse" />
                        <span>{phase === 'requesting' ? 'Accès au microphone…' : phase === 'stopping' ? 'Préparation du vocal…' : 'Enregistrement…'}</span>
                        {phase === 'recording' && <span className="tabular-nums" data-testid={`${prefix}-recording-duration`}>{durationLabel(seconds)}</span>}
                    </div>
                    <Button type="button" size="sm" variant="ghost" onClick={recorder.discard} title="Annuler l’enregistrement" data-testid={`${prefix}-cancel-recording`}>
                        <Trash2 className="mr-1.5 h-4 w-4" />Annuler
                    </Button>
                    <Button type="button" size="sm" variant="outline" onClick={recorder.stop} disabled={phase !== 'recording'} data-testid={`${prefix}-stop-recording`}>
                        <Square className="mr-1.5 h-3.5 w-3.5" />Arrêter
                    </Button>
                </div>
            )}
            {phase === 'ready' && draft && (
                <div className="min-w-0 space-y-2 rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid={`${prefix}-voice-draft`}>
                    <p className="text-xs font-medium text-slate-700" data-testid={`${prefix}-voice-draft-status`}>
                        {sending ? 'Envoi du vocal…' : draft.limitReached ? 'Durée maximale atteinte · Vocal prêt' : 'Vocal prêt'}
                    </p>
                    <VoiceMessagePlayer blobUrl={draft.url} seed={draft.file.name} durationHint={draft.duration} disabled={sending} testIdPrefix={`${prefix}-voice-preview`} />
                    <div className="flex flex-wrap justify-between gap-2">
                        <Button type="button" size="sm" variant="ghost" onClick={onDiscard || recorder.discard} disabled={sending} data-testid={`${prefix}-discard-voice`}>
                            <Trash2 className="mr-1.5 h-4 w-4" />Supprimer
                        </Button>
                        <Button type="button" size="sm" onClick={onSend} disabled={sending} data-testid={`${prefix}-send-voice`}>
                            {sending ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Send className="mr-1.5 h-4 w-4" />}Envoyer le vocal
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};